import { glossary } from "@/mocks/glossary";

export default function GlossarySection() {
  return (
    <section id="glossary" className="w-full bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="max-w-2xl">
          <p className="eyebrow">
            <i className="ri-book-open-line" aria-hidden="true"></i>
            吃瓜百科
          </p>
          <h2 className="section-title mt-4">六个词，看懂围观的门道</h2>
          <p className="mt-4 font-body text-sm leading-relaxed text-foreground-600 md:text-base">
            围观也是有方法的。弄懂这几个常见概念，你在看任何一场讨论时，都能更快分辨哪些是事实、哪些只是情绪。
          </p>
        </div>

        <dl className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {glossary.map((item) => (
            <div key={item.term} className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
              <dt className="flex items-center gap-3">
                <span className="flex h-10 w-10 items-center justify-center rounded-md bg-secondary-100 text-lg text-secondary-700">
                  <i className={item.icon} aria-hidden="true"></i>
                </span>
                <span className="font-heading text-base font-bold text-foreground-950">{item.term}</span>
              </dt>
              <dd className="mt-3 font-body text-sm leading-relaxed text-foreground-600">{item.desc}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}